module.exports = __webpack_public_path__ + "img/375.49e61e0d.jpg";